export default __webpack_public_path__ + "static/media/header.8160311f.svg";